<template>
  <b-modal
    id="modal-change-seq-vendor"
    modal-class="mc-modal-change-seq-vendor"
    title="Ubah Urutan Penugasan?"
    size="md"
    centered
    scrollable
  >
    <p>
      {{ 'Perubahan ini akan menghapus ' }}<strong>Nama Vendor</strong>{{ ' yang telah dipilih.' }}
      <br />
      {{ 'Pilih kembali Nama Vendor untuk menyelesaikan pembuatan penugasan baru.' }}
    </p>
    <template #modal-footer="{ cancel }">
      <b-button size="md" variant="outline-primary" @click="cancel()">
        {{ $t('global.action.cancel') }}
      </b-button>
      <b-button size="md" variant="primary" @click="change()">
        {{ 'Ubah Urutan' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      fromAttachDelivery: false,
    }
  },
  mounted() {
    this.$root.$on('bv::show::modal', (modalId, data) => {
      if (modalId === 'modal-change-seq-vendor') {
        this.fromAttachDelivery = data?.fromAttachDelivery
      }
    })
  },
  methods: {
    async change() {
      if (this.fromAttachDelivery) {
        this.$emit('change-vendor', true)
        const query = this.$route.query
        this.$router.push({
          name: 'Fleet Task Attach Delivery',
          params: {
            id: this.$route.params.id,
          },
          query,
        })
      } else {
        this.$emit('change-vendor', true)
      }
      this.$bvModal.hide('modal-change-seq-vendor')
    },
  },
}
</script>
